import { render, staticRenderFns } from "./MarginKpiPopup.vue?vue&type=template&id=c7b16eac&scoped=true&"
import script from "./MarginKpiPopup.vue?vue&type=script&lang=js&"
export * from "./MarginKpiPopup.vue?vue&type=script&lang=js&"
import style0 from "./MarginKpiPopup.vue?vue&type=style&index=0&id=c7b16eac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b16eac",
  null
  
)

export default component.exports